<ui-section
	[collapsable]="true"
	[collapsed]="shouldCollapseSignal()"
	[title]="sectionTitle"
	(onCollapsedChange)="onCollapsedChange($event)"
	[testHook]="testHooks.TitleSection"
>
	<div section-content class="grid grid-cols-2 gap-12">
		<div class="flex flex-col gap-6 h-fit">
			<div class="flex flex-col gap-4">
				<h4 class="text-lg font-medium text-gray-950 m-0">Fee Placement</h4>

				<app-direction-of-fee-dropdown
					[currentDirectionOfFee]="assystSettingsSignal()?.location"
					label="Display Line Item(s) In"
					fieldToUpdate="{{ firestoreDefaultSettingsPath }}.location"
					intercomAttr="sign-it-display-amount-setting"
				/>

				<app-input
					*ngIf="assystSettingsSignal()?.location !== directionOfFeeType.NONE"
					type="cents"
					[ngModel]="assystSettingsSignal()?.amount"
					(debounce)="setAmount($event)"
					label="Fee Amount (Per Mortgage)"
					[testHook]="testHooks.Input"
				/>
			</div>
		</div>

		<div
			class="flex flex-col gap-6 h-fit"
			*ngIf="assystSettingsSignal()?.location !== directionOfFeeType.NONE"
		>
			<div class="flex flex-col gap-4">
				<h4 class="text-lg font-medium text-gray-950 m-0">
					Additional Settings
				</h4>

				<ui-checkbox
					label="Fee subject to HST"
					[ngModel]="assystSettingsSignal()?.hst"
					(ngModelChange)="setHst($event)"
					data-intercom-target="sign-it-fee-amount-setting"
					[testHook]="testHooks.FeeSubjectToHstCheckbox"
				/>
			</div>
		</div>
	</div>
</ui-section>
